const TOKENS_PER_MILLION = 1_000_000
const SMALLEST_SHOWN_MILLIONS = 0.01

export function formatTokensM(tokens: number): string {
  if (tokens <= 0) return '0.00 M'

  const millions = tokens / TOKENS_PER_MILLION
  if (millions < SMALLEST_SHOWN_MILLIONS) return '< 0.01 M'

  return `${millions.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} M`
}

export function isCreditOnlyUsage(totalTokens: number, costUsd: number): boolean {
  return totalTokens === 0 && costUsd > 0
}

export function formatTokenCell(totalTokens: number, tokens: number, costUsd: number): string {
  return isCreditOnlyUsage(totalTokens, costUsd) ? '—' : formatTokensM(tokens)
}

export function formatCost(cost: number): string {
  return `$ ${cost.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}
